import React from 'react';
import ReactDOM from 'react-dom';
import '@missionlabs/smartagent-app-components/dist/index.css';
import './index.css';
import 'typeface-rubik';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
